define('views/pages/HomePageView',[
        'underscore',
        'jquery',
        'PageView',
        'app',
        'WidgetCollectionView',
        'template!index',
        'BannerMessageView',
        'IndicatorMessageView'],
    function (_, $, PageView, app, WidgetCollectionView, homeTemplate, BannerMessageView, IndicatorMessageView) {

    var view;
    var isGlobalSiteSwitcher;

    return PageView.extend({
        pageName:'Home',
        events:{
            'click .scroll-top-btn': 'scrollTop'
        },

        initialize:function(options){

            view = this;

            // PageView constructor heritage
            PageView.prototype.initialize.apply(this,arguments);
            //
            isGlobalSiteSwitcher = !!view.$('#global-site-switcher').get(0)
            if(isGlobalSiteSwitcher) {
                // si on est dans le cas
                return;
            }
            //
            view.render();
            //$('#home-preloader').remove()
            //
            //
            view.listenTo(app, 'scroll', view.onScroll);

        },
        initialRender:function(){
            if(isGlobalSiteSwitcher) return;
            //
            // webview hot fix,
            // si on est dans l'app, et qu'on arrive sur la home,
            // on est redirigé vers le panier
            //
            var scrollTop = app.get('scrollTop');
            //
            var collection = new WidgetCollectionView('home');
            view.$('.widgets-content').html(collection.el);
            view.attachView(collection);

            view.attachView(new BannerMessageView('home_top_banner'));
            view.attachView(new IndicatorMessageView('home_header_widget'));

            app.scrollTop(scrollTop)
        },
        render:function(){
            view.$el.html(homeTemplate());
            view.delegateEvents();
        },
        scrollTop: function(){
            app.scrollTop(0, 400);
        },
        onScroll: function(){
            var btnScroll = this.$('.scroll-top-btn');
            if(app.get('scrollTop') > 500){
                btnScroll.addClass('active');
            }else{
                btnScroll.removeClass('active');
            }
        },
        initialMetaTitle:function(){
            if(!isGlobalSiteSwitcher) document.title = app.c('_META_TITLE_');
        }
    })

})
;
